export default "__VITE_ASSET__ClNyQwro__"